import type { FaireProductEntity } from "../../entity_types/product";

export const p_u5efj5uue5: FaireProductEntity = {
  token: "p_u5efj5uue5",
  type: "product",
  name: "Shower steamers | Lavender mint | 2 pack Thank You",
  brandToken: "b_bz352u88",
  brandName: "Thulisa Naturals™  | Bath + Body",
  imageUrl:
    "https://cdn.faire.com/fastly/ad3b381fd60f1adf0dcec0b5e840ebf6d6c3228f77ca5fb8d7ead0b939f7c06b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3a78ab95f7499624535f5d10441f4a3f35afb3284e9ddf42775d0f889ba8015.jpeg",
    "https://cdn.faire.com/fastly/3fe95f3e99cf5befe9269dc5ce7ff70168aa53b1e874dcbd3ca99996bf32d2f3.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "Spread self-care with our Lavender Mint Shower Steamers, beautifully packaged in an elegant 'Thank You' box that brings joy to any occasion. Infused with a refreshing blend of lavender and mint, these shower steamers create an uplifting yet soothing aromatherapy experience. These Thank-you shower steamers are perfect for everyday gratitude, employee or client gifting, and more. They're a meaningful, affordable way to add positivity to someone’s day\n\n•Each box contains 2 Lavender mint shower steamers\n•Made in the USA  Fairfax, VA\n•We donate a portion of sales to provide free lunches to vulnerable preschoolers in South Africa\n•Perfect size and price point to place at your cash register.\n•Recycle and compostable packaging\n•Leaping Bunny certified\n•Great  Mother's day gifts\n•perfect for teacher gifts, mental health kits, gratitude displays, or wellness-focused retail.\n\n\n\n\n",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:09.913Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
